import { AxiosRequestConfig } from 'axios'
import { Options } from 'axios-hooks'
import { LogProps } from 'utils/log'

/**
 * APIのドメイン
 */
export const DOMAIN = process.env.REACT_APP_QN_API_DOMAIN

/**
 * APIの定義
 */
export const API: ApisProps = {
  LOG: {
    config: {
      url: '/api/v1/log/client',
      method: 'POST',
    },
    options: { manual: true },
    disableErrorLog: true,
  },
  QN_STATUS: {
    config: {
      url: '/api/v1/qn-status',
      method: 'GET',
    },
    options: { manual: true },
  },
  REQUEST: {
    config: {
      url: '/api/v1/request',
      method: 'POST',
    },
    options: { manual: true },
  },
  IMAGES: {
    config: {
      url: '/api/v1/images',
      method: 'POST',
    },
    options: { manual: true },
  },
  MAINTENANCE: {
    config: {
      url: '/api/v1/maintenance-status',
      method: 'GET',
    },
    options: { manual: true },
  },
}

/**
 * 型定義：API定義
 */
export type ApisProps = {
  [NAME: string]: ApiProps
}

/**
 * 型定義：個別のAPI定義
 */
export type ApiProps = {
  config: AxiosRequestConfig
  options?: Options
  /**
   * 明示的にtrueを指定した場合、エラーログ送信を停止する
   */
  disableErrorLog?: boolean
}

/**
 * 型定義：要請者入力情報連携APIのパラメータ
 */
export type RequestAPIPayloadProps = {
  /** 1: 連絡内容 */
  contactContentCd: string
  // APIでは必須ではないが、この項目がない=フロントのpayload構築不備と判断できるため、必須とする
  /** 2: トラブル詳細 */
  troubleDetailContent: string
  /** 3: 事故種類 */
  accTypeCd?: string
  /** 4: トラブル内容 */
  troubleContentCd?: string
  /** 5: 場所種別 */
  troubleLocTypeCd: string
  /** 6: 駐車場の形状 */
  troubleLocParkingCd?: string
  /** 7: トラブル場所 */
  troubleLocLocation: string
  /** 8: 緯度 */
  troubleLocLatitude: string
  /** 9: 経度 */
  troubleLocLongitude: string
  /** 10: 目印／進行方向 */
  troubleLocMark?: string
  /** 11: 希望搬送先 */
  carryDestAddress?: string
  /** 12: 改造 */
  puncRemodelCd?: string
  /** 13: 県境超え */
  crossPrefBorder?: string
  /** 14: パンク箇所（普通） */
  puncPlcNormCd?: string
  /** 15: スペアタイヤの有無 */
  puncSpareTireExistCd?: string
  /** 16: 破損個所【複数】 */
  collAccPlcCd?: string
  /** 17: 破損個所のタイヤの状態 */
  collAccPlcTireCd?: string
  /** 18: 落輪した場所 */
  dropLocationCd?: string
  /** 19: 乗り上げた場所 */
  rideLocationCd?: string
  /** 20: 油種 */
  outGasOilTypeCd?: string
  /** 21: 入力情報 */
  input: string
  /** 22: 移動費用特約の有無 */
  raTransferScWishes?: string
  /** 23: 宿泊費用特約の有無 */
  raLodgingScWishes?: string
  /** 24: 代車費用特約の有無 */
  raLcarCostScWishes?: string
  /** 25: 代車補足内容 */
  raLcarCostScSupplWishes?: string
  /** 26: 予約日付 */
  reservationDate?: string
  /** 27: 予約時間 */
  reservationTime?: string
  /** 29: 要請者名(ｶﾅ) */
  requesterNameKana?: string
  /** 30: 電話番号 */
  tel?: string
  /** 31: 種別 */
  kinds?: string
  /** 32: 車体登録番号 */
  bodyRegistrationNum?: string
  /** 33: 車両種別 */
  vehicleType?: string
  /** 34: 積荷 */
  cargo?: string
  /** 35: JAF会員確認 */
  jafMembershipConfirmation?: string
  /** 36: JAF会員番号 */
  jafMembershipNumber?: string
  /** 37: JAF会員名 */
  jafMembershipName?: string
  /** 38: 車高 */
  vehicleHeight?: string
  /** 39: 要請者２_備考 */
  requester2Remarks?: string
  /** 40: パンク箇所（二輪） */
  puncPlcTwoWheeledVehicleCd?: string
  /** 41: パンクした経緯 */
  backgroundOfThePuncture?: string
  /** 42: 落輪箇所（普通） */
  fallingPartNormaMultipleCd?: string
  /** 43: 乗り上げ箇所 */
  ridingPointNormalMultipleCd?: string
  /** 44: 保険種類 */
  insuranceType?: string
  /** 45: 搬送先 */
  transportDestination?: string
  /** 46: 搬送先名 */
  destinationName?: string
  /** 47: 搬送先電話番号 */
  destinationPhoneNumber?: string
  /** 48: トラブル発生日時 */
  troubleOccurDateTime?: string
  /** 49: 希望する対応 */
  desiredResponse?: string
  /** 50: 新旧ドメイン識別子 */
  snDomainDecisionFlg?: string
  /** 50: 契約者名 */
  contractorName?: string
  /** 51: QN途中入力フラグ */
  qnInputEscapeFlg: string
}

/**
 * 型定義：要請者写真登録APIのパラメータ
 */
export type ImagesAPIPayloadProps = {
  surrounding?: string
  damagedDetail?: string
  vehicleCloseUp?: string
  landmark?: string
  carVerification?: string
  additional?: string
}

/**
 * 型定義：フロントエンドログ送信APIのパラメータ
 */
export type LogAPIPayloadProps = LogProps
